// Shared contract addresses for Polygon Amoy (testnet) and Polygon (mainnet).
//
// Single source of truth, importable by both Deno edge functions and the
// Vite frontend. Keep this file free of runtime-specific syntax (no
// `import.meta.env`, no Node/Deno globals) so both bundlers can consume it.
//
// `src/config/contracts.ts` re-exports these into the frontend's
// `ChainConfig` shape. Edge functions import the raw maps directly.

export interface ContractAddresses {
  mockUSDC: string;
  questManager: string;
  taskManager: string;
  bountyBoard: string;
  escrowVault: string;
  disputeResolver: string;
  reputationLedger: string;
  userRegistry: string;
}

export const AMOY_CONTRACTS: ContractAddresses = {
  mockUSDC: "0x4d8C72d25187d520B11714d0E4BCcBF04e231CcF",
  questManager: "0x840FAc5C3410BE45e3736580EaC3f2fe1F165f5e",
  taskManager: "0x0AB84342fA090181E789Ae116f76e7383ff640eb",
  bountyBoard: "0x8CdB4Bfa8211Ab9588C1F7CA9ff0c2977F93Bd0C",
  escrowVault: "0x45818C4a44abed733D86d16B84279bAea19FEdf9",
  disputeResolver: "0x45fd9efa893FE7b6a38e8Fd5b7170AFf513C79b9",
  reputationLedger: "0x84f054b634a56bbcA1b6090587a8b83f727c6D07",
  userRegistry: "0x5F12126E97a2E1c1bAfa8dA5B2695636Dd0400FF",
};

export const POLYGON_CONTRACTS: ContractAddresses = {
  mockUSDC: "", // Not used on mainnet — uses native USDC
  questManager: "0x00B1A346E4574fCCE2935D7FA1D0baCD2E34cB32",
  taskManager: "0x4CA9C8fcEECaeE4A1F239DEB84Ed48F60C6F36a8",
  bountyBoard: "0xF755a6C738F6b4457877cf6eB39316Fa1EF69023",
  escrowVault: "0x05B9b80DA19Ae8706f356742996710b6A441e191",
  disputeResolver: "0xA231f37e30548dF5a40Cf1cBf42b7fC8b9F9153c",
  reputationLedger: "0x82fB932246185F5bC4933935DdAacdc09751f7D6",
  userRegistry: "0x2fECFbCA56729b03D41aB4E47d61aDdE969a6D47",
};

export const AMOY_TOKENS = {
  USDC: "0x4d8C72d25187d520B11714d0E4BCcBF04e231CcF",
  USDT: "0x754dBeb43b40B0De6ab742bB9FA8D89990124336",
} as const;

export const POLYGON_TOKENS = {
  USDC: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
  USDT: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
} as const;
